export default "__VITE_ASSET__Bq7ezNAn__"